import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { getSessionResults } from '../../services/neonDb';
import Results from '../Results';

const ResultsPage = ({ sessionId }) => {
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchResults = async () => {
      try {
        const sessionResults = await getSessionResults(sessionId);
        // Transform the data into the format expected by Results component
        const transformedResults = {
          sessionId,
          questions: sessionResults
            .filter(result => result.ranking_data && result.type !== 'final')
            .map(result => {
              const data = typeof result.ranking_data === 'string' 
                ? JSON.parse(result.ranking_data)
                : result.ranking_data;
              return {
                ...data,
                questionKey: result.type,
                completionTime: result.created_at,
                rankings: data.rankings.map(rank => ({
                  ...rank,
                  score: parseFloat(rank.score)
                }))
              };
            })
        };
        setResults(transformedResults);
      } catch (err) {
        setError('Failed to load results');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (sessionId) {
      fetchResults();
    }
  }, [sessionId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return <Results results={results} />;
};

export default ResultsPage;